module.exports = __webpack_public_path__ + "media/landing_page/instacart-divvy-lockup-478bd564.svg";